import gql from 'graphql-tag';

const CREATE_CASE_MUTATION_NAME =
  'compositions_DealerLocator_createCaseMutation';

const createCaseMutation = gql`
  mutation ${CREATE_CASE_MUTATION_NAME} {
    createCase {
      case {
        id
        caseNumber
      }
    }
  }
`;

export default createCaseMutation;



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/DealerDetails/NewCaseFromLocation/createCaseMutation.js